export default __webpack_public_path__ + "static/media/avatar_default.fd92208b.png";